import { paletteColors } from '@evaneos/b2b-ui';
import FlakeIcon from '@evaneos/b2b-ui/icons/AcUnitOutlined';
import FireIcon from '@evaneos/b2b-ui/icons/LocalFireDepartmentOutlined';
import SunIcon from '@evaneos/b2b-ui/icons/WbSunnyOutlined';
import { ReactElement } from 'react';

import { Heat } from '../../../resources/dossier/types';
import { AllTranslationKeys } from '../../intl/types';

type HeatProperties = {
    labelId: AllTranslationKeys;
    accentColor: Record<string, string>;
    icon: ReactElement;
};

export const heatMap: Record<Exclude<Heat, Heat.NONE>, HeatProperties> = {
    [Heat.HOT]: {
        labelId: 'dossier.closing_confidence.heat_level.hot',
        accentColor: paletteColors.red,
        icon: <FireIcon />,
    },
    [Heat.WARM]: {
        labelId: 'dossier.closing_confidence.heat_level.warm',
        accentColor: paletteColors.yellow,
        icon: <SunIcon />,
    },
    [Heat.COLD]: {
        labelId: 'dossier.closing_confidence.heat_level.cold',
        accentColor: paletteColors.blue,
        icon: <FlakeIcon />,
    },
};
